import { takeLatest } from 'redux-saga/effects';

import { API_ACTION_TYPES } from '../actions';
import authTokenExpired from './authTokenExpired';

export default function* watchersSaga() {
  yield takeLatest(API_ACTION_TYPES.AUTH.TOKEN_EXPIRED, authTokenExpired);
}
